export default "/images/9c6d4968acad81f41991cfed6f420e82.avif";